import { Provider } from '@angular/core';

import { runOnFeatureInit } from '@frontend/vanilla/core';

import { WidgetRegistrationService } from './widget-registration.service';

export const provide = (): Provider => {
    return runOnFeatureInit(WidgetRegistrationService);
};
